// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PTrademarkOutlinedSvg from "@fishx/icons-svg/es/asn/PTrademarkOutlined";
import FishxIcon from '../components/FishxIcon';

var PTrademarkOutlined = function PTrademarkOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PTrademarkOutlinedSvg
  }));
};

PTrademarkOutlined.displayName = 'PTrademarkOutlined';
export default React.forwardRef(PTrademarkOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PTrademarkOutlined.js
// module id = 3694
// module chunks = 0